import { UserAvatar } from '@/components/user-avatar'
import { Button } from '@journ/ui/button'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@journ/ui/card'
import { useSelector } from '@/libs/state'
import { useIntlayer } from 'react-intlayer'
import { session$ } from '@/features/auth/store'
import { MemberEditSheet } from '@/features/hr/ui/member-edit-sheet'
import { useMemberParams } from '@/features/hr/ui/use-member-params'
import { ThemeSwitch } from './theme-switch'

const ProfileCard = () => {
	const content = useIntlayer('settings-general')
	const user = useSelector(() => session$.user.get())
	const { setParams } = useMemberParams()

	if (!user) return null

	const displayName = user.fullName ?? user.email

	return (
		<Card>
			<div className='flex items-center justify-between pr-6'>
				<CardHeader>
					<CardTitle>{content.profile.title}</CardTitle>
					<CardDescription>{content.profile.description}</CardDescription>
				</CardHeader>
				<UserAvatar name={displayName} avatarUrl={user.avatarUrl} size='xl' />
			</div>
			<CardFooter className='flex justify-between'>
				<div>{user.email}</div>
				<Button variant='outline' onClick={() => setParams({ memberId: user.id })}>
					{content.profile.edit}
				</Button>
			</CardFooter>
		</Card>
	)
}

const AppearanceCard = () => {
	const content = useIntlayer('settings-general')

	return (
		<Card>
			<CardHeader>
				<CardTitle>{content.appearance.title}</CardTitle>
				<CardDescription>{content.appearance.description}</CardDescription>
			</CardHeader>
			<CardContent>
				<ThemeSwitch />
			</CardContent>
		</Card>
	)
}

const GeneralSettings = () => (
	<div className='space-y-6 mt-4'>
		<ProfileCard />
		<AppearanceCard />
		<MemberEditSheet />
	</div>
)

export { GeneralSettings }
